var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeatherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 119,
    viewBox: "0 0 86 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_581_25240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2092 74.384C20.2092 76.0282 20.5265 77.625 21.1521 79.1301C21.7565 80.5839 22.6232 81.8949 23.7282 83.0267C24.2724 83.5841 24.8719 84.0925 25.51 84.5378C26.1537 84.9869 26.8426 85.3759 27.5576 85.6941C29.0427 86.3547 30.625 86.7108 32.2607 86.7524L32.2687 86.7526L32.2766 86.7534C32.5172 86.7779 32.7627 86.7903 33.0063 86.7903C33.6313 86.7903 34.2515 86.7094 34.8494 86.5498L34.8572 86.5478L34.865 86.5463C36.2783 86.2827 37.6237 85.7777 38.8638 85.0454C40.0781 84.3283 41.1546 83.4158 42.0631 82.3333C42.9785 81.2428 43.6925 80.0161 44.1855 78.6874C44.6957 77.3123 44.9544 75.8644 44.9544 74.384C44.9544 73.4141 44.8418 72.4484 44.6197 71.5137C44.4039 70.6052 44.0835 69.7202 43.6673 68.8831C43.2585 68.0609 42.756 67.2822 42.1738 66.5685C41.595 65.859 40.9364 65.2125 40.2164 64.6471L40.1362 64.5841V64.4822L40.1362 35.3396C40.1362 34.377 39.9477 33.4433 39.576 32.5644C39.2169 31.7154 38.7028 30.9529 38.0479 30.298C37.393 29.6431 36.6305 29.129 35.7815 28.7699C34.9026 28.3982 33.9689 28.2097 33.0063 28.2097C32.0436 28.2097 31.1099 28.3982 30.231 28.7699C29.382 29.129 28.6195 29.6431 27.9646 30.298C27.3098 30.9529 26.7956 31.7154 26.4365 32.5644C26.0648 33.4433 25.8763 34.377 25.8763 35.3396L25.8763 63.8707V63.9837L25.782 64.0458C24.1037 65.1519 22.7047 66.6659 21.7364 68.4242C21.2442 69.318 20.8645 70.271 20.6078 71.2565C20.3434 72.272 20.2092 73.3243 20.2092 74.384ZM19.9995 74.384C19.9995 69.9891 22.2524 66.1208 25.6666 63.8707L25.6666 35.3396C25.6666 31.286 28.9527 28 33.0063 28C37.0599 28 40.3459 31.286 40.3459 35.3396L40.3459 64.4822C43.2794 66.7857 45.1641 70.3649 45.1641 74.384C45.1641 80.5398 40.7434 85.6631 34.9035 86.7524C34.2983 86.914 33.6624 87 33.0063 87C32.7527 87 32.5024 86.9872 32.2554 86.9621C25.4571 86.7892 19.9995 81.2239 19.9995 74.384Z",
    fill: "#00B8D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0508 74.5425C23.0504 72.7678 23.5396 71.0273 24.4646 69.5127C25.3895 67.9981 26.7144 66.768 28.2934 65.9578V55.4595H37.1009V65.9576C38.6254 66.7399 39.914 67.914 40.8342 69.3594C41.7544 70.8047 42.2731 72.4691 42.3368 74.1814C42.4005 75.8936 42.007 77.5919 41.1968 79.1017C40.3865 80.6115 39.1888 81.8782 37.7266 82.7715C36.2645 83.6649 34.5909 84.1527 32.8777 84.1848C31.1646 84.2168 29.4738 83.792 27.9793 82.954C26.4848 82.116 25.2404 80.8951 24.3742 79.4167C23.508 77.9383 23.0512 76.2559 23.0508 74.5425Z",
    fill: "#FF5630"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_581_25240",
    x: 0,
    y: 0,
    width: 85.1641,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.627451 0 0 0 0 0.941176 0 0 0 0.596 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_25240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_25240",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherIcon);
export default __webpack_public_path__ + "static/media/WeatherIcon.da23da70b97290f04d85feff801badb1.svg";
export { ForwardRef as ReactComponent };